module.exports = __webpack_public_path__ + "files/9d651d2d3625acea36a96ca904f57549.svg";